<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Entradas de Materiais</h1>
        <p class="text-sm text-gray-500">Gerencie as entradas e notas fiscais</p>
      </div>
      <button
        (click)="createEntry()"
        class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded flex items-center gap-2"
      >
        <i class="pi pi-plus"></i>
        Nova Entrada
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
      <input
        type="text"
        (input)="onSearchChange()"
        [(ngModel)]="searchTerm"
        placeholder="Buscar por chave ou fornecedor..."
        class="border border-gray-300 rounded px-3 py-2 text-sm"
      />
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} entrada(s) encontrada(s)
      </div>
    </div>
  </div>

  <div class="px-6 py-2"></div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="entries"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Chave NF</th>
            <th class="text-left px-6 py-3">Data / Hora</th>
            <th class="text-left px-6 py-3">Fornecedor</th>
            <th class="text-left px-6 py-3">Total</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono text-gray-900">{{ entry.accessKey || '-' }}</td>
            <td class="px-6 py-2">{{ entry.issueDateTime ? (entry.issueDateTime | date:'dd/MM/yyyy HH:mm') : ((entry.emissionDate || '') + (entry.emissionTime ? ' ' + entry.emissionTime : '')) || '-' }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ entry.supplierName || entry.supplier?.companyName || '-' }}</td>
            <td class="px-6 py-2">{{ (entry.total != null ? entry.total : entry.totalPurchase) != null ? ((entry.total ?? entry.totalPurchase) | number:'1.2-2':'pt-BR') : '-' }}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Visualizar"
                  icon="pi pi-eye"
                  [text]="true"
                  severity="secondary"
                  (click)="viewEntry(entry)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-8 text-gray-500">
              Nenhuma entrada encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
